import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

const HorizontalCalendar = ({ selectedDate, onSelectDate }) => {
    const [startOfWeek, setStartOfWeek] = React.useState(() => {
        const d = new Date();
        const day = d.getDay(); // 0 is Sunday
        const diff = d.getDate() - day; // adjust when day is sunday
        return new Date(d.setDate(diff));
    });

    const dates = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(startOfWeek);
        d.setDate(startOfWeek.getDate() + i);
        dates.push(d);
    }

    const handlePrevWeek = () => {
        const d = new Date(startOfWeek);
        d.setDate(d.getDate() - 7);
        setStartOfWeek(d);
    };

    const handleNextWeek = () => {
        const d = new Date(startOfWeek);
        d.setDate(d.getDate() + 7);
        setStartOfWeek(d);
    };

    const isSelected = (d) => {
        return d.toDateString() === selectedDate.toDateString();
    };

    const isToday = (d) => {
        return d.toDateString() === new Date().toDateString();
    };

    return (
        <div className="flex items-center justify-between mb-6 bg-card rounded-xl border p-2 shadow-sm">
            <Button variant="ghost" size="icon" onClick={handlePrevWeek} className="h-8 w-8">
                <ChevronLeft className="w-4 h-4" />
            </Button>

            <div className="flex flex-1 justify-between px-2 gap-1 overflow-x-auto">
                {dates.map((date) => (
                    <button
                        key={date.toISOString()}
                        onClick={() => onSelectDate(date)}
                        className={cn(
                            "flex flex-col items-center justify-center min-w-[2.5rem] py-2 rounded-lg transition-all",
                            isSelected(date)
                                ? "bg-primary text-primary-foreground shadow-md scale-105"
                                : "hover:bg-accent text-muted-foreground hover:text-foreground",
                            isToday(date) && !isSelected(date) && "bg-accent/50 text-accent-foreground font-semibold"
                        )}
                    >
                        <span className="text-[10px] uppercase font-medium">
                            {date.toLocaleDateString('pt-BR', { weekday: 'short' }).slice(0, 3)}
                        </span>
                        <span className={cn("text-lg font-bold", isSelected(date) ? "text-primary-foreground" : "")}>
                            {date.getDate()}
                        </span>
                    </button>
                ))}
            </div>

            <Button variant="ghost" size="icon" onClick={handleNextWeek} className="h-8 w-8">
                <ChevronRight className="w-4 h-4" />
            </Button>
        </div>
    );
};

export default HorizontalCalendar;
